var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1148"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1148"
    },
    "bundlingPackage": "academy-public-ui",
    "bundlingPackageVersion": "static-1.12074",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};